import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, Icon } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

interface LocationState {
  vehicleUnitNumber?: number;
  message?: string;
}

const VehicleServiceUpdateSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  return (
    <MDBox>
      <Card>
        <MDBox p={4} textAlign="center">
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="80px"
            height="80px"
            borderRadius="50%"
            bgcolor="success.main"
            mx="auto"
            mb={3}
          >
            <Icon sx={{ fontSize: 40, color: "white" }}>check</Icon>
          </MDBox>

          <MDTypography variant="h4" fontWeight="medium" mb={1}>
            Submission Successful
          </MDTypography>

          <MDTypography variant="body1" color="text" mb={1}>
            {state?.message || "Vehicle service update has been submitted successfully."}
          </MDTypography>

          {state?.vehicleUnitNumber && (
            <MDTypography variant="body2" color="text" mb={3}>
              Vehicle Unit: {state.vehicleUnitNumber}
            </MDTypography>
          )}

          <MDBox display="flex" justifyContent="center" gap={2} mt={4}>
            <MDButton
              variant="outlined"
              color="secondary"
              onClick={() => navigate("/forms/vehicle-service-update")}
            >
              Submit Another
            </MDButton>
            <MDButton variant="contained" color="dark" onClick={() => navigate("/forms")}>
              Back to Forms
            </MDButton>
          </MDBox>
        </MDBox>
      </Card>
    </MDBox>
  );
};

export default VehicleServiceUpdateSuccess;
